const route = [
    {//登录
        path: '/login',
        component: function (resolve) {
            require(['VIEWS/login/login.vue'], resolve);
        }
    },
    {//登录
        path: '/devlogin',
        component: function (resolve) {
            require(['VIEWS/login/login_dev.vue'], resolve);
        }
    },
    {
        path: '/zxez_login',
        component: function (resolve) {
            require(['VIEWS/login/zxez_login.vue'], resolve);
        }
    },
    {//首页
        path: '/',
        redirect: "/index",
        component: function (resolve) {
            require(['VIEWS/base/layout.vue'], resolve);
        },
        children: [
            {
                path: '/index',
                component: function (resolve) {
                    require(['VIEWS/base/index.vue'], resolve);
                },
            },
            {
                path: '/courseware',
                meta: { keepAlive: true },
                component: function (resolve) {
                    require(['VIEWS/base/courseware.vue'], resolve);
                },
            },
            {
                path: '/classlist',
                meta: { keepAlive: false },
                component: function (resolve) {
                    require(['VIEWS/class/classlist.vue'], resolve);
                },
            },
            {
                path: '/mine',
                meta: { keepAlive: false },
                component: function (resolve) {
                    require(['VIEWS/mine/mine.vue'], resolve);
                },
            },
        ]
    },
    {//选择学科
        //type：0发作业  1检查作业 
        path: '/subjectChoose/:type',
        component: function (resolve) {
            require(['VIEWS/subjectChoose/subjectChoose.vue'], resolve);
        }
    },
    {
        //设置教材 subject //学科
        // type 获取教材列表 1教材,教辅 2 默认为教材
        // 设置教材列表 0教材,教辅 1 默认为教材
        // code
        // 001  课件模块
        // 002  数学 视频作业
        // 003  数学 速算作业
        // 004  数学 同步习题  单元复习
        // 005  英语课前预习
        // 006  英语课后练习
        // 007  语文课前预习
        // 008  语文课后练习
        path: '/setBook/:subject/:type/:code',
        component: function (resolve) {
            require(['COMPONENTS/base/setBook.vue'], resolve);
        }
    },
    {//教师作业列表
        path: '/tea/taskList',
        component: function (resolve) {
            require(['COMPONENTS/base/tea_taskList.vue'], resolve);
        }
    },
    {//教师发布作业 之后分享的页面
        //type: 0不显示查看结果按钮，1显示查看结果按钮，跳转路由需要存到localStorage,存储名为：star_url
        path: '/release/share',
        component: function (resolve) {
            require(['COMPONENTS/base/share.vue'], resolve);
        }
    },
    {//教师发布作业 之后发送短信的页面
        //type: 0不显示查看结果按钮，1显示查看结果按钮，跳转路由需要存到localStorage,存储名为：star_url
        path: '/release/sendsms',
        component: function (resolve) {
            require(['COMPONENTS/base/sendSMS.vue'], resolve);
        }
    },
    {//教师奖励评语
        path: '/tea/testreward/:sid/:testId/:classId',
        component: function (resolve) {
            require(['COMPONENTS/base/tea_reward.vue'], resolve);
        }
    },
    {//教师奖励评语
        path: '/tea/perreward/:sid/:testId/:userId',
        component: function (resolve) {
            require(['COMPONENTS/base/tea_per_reward.vue'], resolve);
        }
    },
    { //学情列表
        path: '/emotionList',
        component: function (resolve) {
            require(['COMPONENTS/base/emotion_list.vue'], resolve);
        }
    }, { //作业报告
        path: '/base/shareToParent/:uid/:taskId/:taskType/:testType/:sid',
        component: function (resolve) {
            require(['COMPONENTS/base/shareToParent.vue'], resolve);
        }
    }
];
export default route
